import styled from 'styled-components'
import { borderRadius, color, height } from 'theme/mixins'
import { ISkeletonItem } from './types'

const Block = styled.div<ISkeletonItem>`
	@keyframes ant-skeleton-loading {
		0% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0 50%;
		}
	}
	border-radius: ${({ $round }) => ($round ? '50%' : borderRadius('sm'))};
	height: ${({ $size, $height }) => {
		if ($height) return `${$height}px`

		switch ($size) {
			case 'large':
				return height('lg')
			case 'small':
				return height('sm')
			case 'medium':
			default:
				return height('md')
		}
	}};
	width: ${({ $width }) => ($width ? `${$width}px` : '100%')};
	min-width: ${({ $width }) => ($width ? `${$width}px` : undefined)};
	background: linear-gradient(
		90deg,
		${color(['gray', '100'])} 25%,
		${color(['gray', '000'])} 37%,
		${color(['gray', '100'])} 63%
	);
	background-size: 400% 100%;
	animation: ant-skeleton-loading 1.4s ease 0s normal infinite none running;
`

export default { Block }
